import React, { useState } from "react";

import { BrowserRouter } from "react-router-dom";
import Routes from "./routes/routes";

import { useSelector, useDispatch } from "react-redux";
import Loading from "./components/customdesign/Loading";
import { getCookie, getInitialConf } from "./utils/Functions";
import Utils from "./utils/Utils";

import { ToastProvider, toast } from "./components/toast";
import actionTypes from "./redux/action.types";
import { setCulture } from "@syncfusion/ej2-base";
let isExternalLoading = false;
import { L10n } from "@syncfusion/ej2-base";
L10n.load({
  es: Utils.languageEs,
});
setCulture("es");

const Route = (props) => {
  const {
    user,
    showDashboard,
    defLang,
    defConfig,
    requestingLogin,
    failed,
    error,
    success,
    message,
  } = useSelector((state) => state.Login);
  const {
    requesting,
    requesting2,
    proccessname,
    processFailed,
    processMessage,
    processSuccess,
    processError,
    reloadPage,
    messageNonce,
  } = useSelector((state) => state.Process);
  const [isFatching, setIsFatching] = useState(true);

  React.useEffect(() => {
    const fetchFn = async () => {
      setIsFatching(true);
      const formStructure = [];
      var token = getCookie(process.env.REACT_APP_NAME + "_usertoken");
      if (token) {
        var response = await getInitialConf();
      }

      setIsFatching(false);
    };
    fetchFn();
    if (reloadPage) {
      window.location.reload();
    }
  }, [reloadPage]);

  React.useEffect(() => {
    if (failed && error) toast.error(error, "Error");
  }, [failed, error]);

  React.useEffect(() => {
    if (success && message) toast.success(message);
  }, [success, message]);

  // messageNonce en las dependencias: sin él, dos acciones seguidas que
  // produzcan el MISMO texto (ej. "Tareas asignadas" al tomar dos tareas
  // seguidas) no cambian processSuccess/processMessage como valores
  // primitivos -> el efecto no se re-disparaba y el segundo toast no salía.
  React.useEffect(() => {
    if (processSuccess && processMessage) {
      const cfg = defConfig?.[defLang] || {};
      let msg = processMessage;
      if (processMessage === "<Process Succesfull>") msg = cfg.processSuccMessage || "Proceso exitoso";
      if (processMessage === "<Successfully deleted>") msg = cfg.processSuccdelMessage || "Eliminado correctamente";
      toast.success(msg, "Éxito");
    }
  }, [processSuccess, processMessage, messageNonce]);

  React.useEffect(() => {
    if (processFailed && processError) toast.error(processError, "Error");
  }, [processFailed, processError, messageNonce]);

  return isFatching ? (
    ""
  ) : (
    <ToastProvider>
      {requestingLogin && <Loading />}
      {requesting && proccessname !== "getComponentConfig" && <Loading />}
      {requesting2 && <Loading />}

      <BrowserRouter>
        <Routes
          defLang={defLang}
          defConfig={defConfig}
          reloadPage={reloadPage}
        />
      </BrowserRouter>
    </ToastProvider>
  );
};

export default Route;
